"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FullScreenModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _react2 = require("@emotion/react");
var _core = require("../../core");
var _theme = require("../../system/theme");
var _ODThemeLite = require("../../theme/ODThemeLite");
var _NavigationBar = require("./NavigationBar");
var _shared = require("./shared");
var _excluded = ["isOpen", "onRequestClose", "headerIconButtonVariant", "title", "subtitle", "id", "analyticsName", "trackBoxImpression", "trackButtonImpressions", "onBackClick", "showScrollbar", "hasPadding", "themeProps"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_k86gbahkc() {
  var path = "/__w/code/code/js/packages/bricks/src/complex/Modal/FullScreenModal.tsx";
  var hash = "c65488675257bca7796c8f9a6ca8816874c773f8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/complex/Modal/FullScreenModal.tsx",
    statementMap: {
      "0": {
        start: {
          line: 59,
          column: 25
        },
        end: {
          line: 59,
          column: 28
        }
      },
      "1": {
        start: {
          line: 60,
          column: 27
        },
        end: {
          line: 64,
          column: 1
        }
      },
      "2": {
        start: {
          line: 65,
          column: 27
        },
        end: {
          line: 69,
          column: 1
        }
      },
      "3": {
        start: {
          line: 135,
          column: 63
        },
        end: {
          line: 274,
          column: 1
        }
      },
      "4": {
        start: {
          line: 151,
          column: 25
        },
        end: {
          line: 151,
          column: 91
        }
      },
      "5": {
        start: {
          line: 152,
          column: 20
        },
        end: {
          line: 152,
          column: 63
        }
      },
      "6": {
        start: {
          line: 153,
          column: 2
        },
        end: {
          line: 153,
          column: 32
        }
      },
      "7": {
        start: {
          line: 154,
          column: 40
        },
        end: {
          line: 154,
          column: 55
        }
      },
      "8": {
        start: {
          line: 155,
          column: 23
        },
        end: {
          line: 158,
          column: 3
        }
      },
      "9": {
        start: {
          line: 156,
          column: 11
        },
        end: {
          line: 156,
          column: 56
        }
      },
      "10": {
        start: {
          line: 160,
          column: 21
        },
        end: {
          line: 160,
          column: 31
        }
      },
      "11": {
        start: {
          line: 162,
          column: 45
        },
        end: {
          line: 171,
          column: 3
        }
      },
      "12": {
        start: {
          line: 173,
          column: 45
        },
        end: {
          line: 185,
          column: 3
        }
      },
      "13": {
        start: {
          line: 187,
          column: 23
        },
        end: {
          line: 208,
          column: 3
        }
      },
      "14": {
        start: {
          line: 210,
          column: 2
        },
        end: {
          line: 273,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 135,
            column: 63
          },
          end: {
            line: 135,
            column: 64
          }
        },
        loc: {
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 274,
            column: 1
          }
        },
        line: 150
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 156,
            column: 5
          }
        },
        loc: {
          start: {
            line: 156,
            column: 11
          },
          end: {
            line: 156,
            column: 56
          }
        },
        line: 156
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 136,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 136,
            column: 11
          },
          end: {
            line: 136,
            column: 16
          }
        }],
        line: 136
      },
      "1": {
        loc: {
          start: {
            line: 138,
            column: 2
          },
          end: {
            line: 138,
            column: 34
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 138,
            column: 28
          },
          end: {
            line: 138,
            column: 34
          }
        }],
        line: 138
      },
      "2": {
        loc: {
          start: {
            line: 146,
            column: 2
          },
          end: {
            line: 146,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 146,
            column: 18
          },
          end: {
            line: 146,
            column: 22
          }
        }],
        line: 146
      },
      "3": {
        loc: {
          start: {
            line: 147,
            column: 2
          },
          end: {
            line: 147,
            column: 19
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 147,
            column: 15
          },
          end: {
            line: 147,
            column: 19
          }
        }],
        line: 147
      },
      "4": {
        loc: {
          start: {
            line: 151,
            column: 25
          },
          end: {
            line: 151,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 151,
            column: 33
          },
          end: {
            line: 151,
            column: 64
          }
        }, {
          start: {
            line: 151,
            column: 67
          },
          end: {
            line: 151,
            column: 91
          }
        }],
        line: 151
      },
      "5": {
        loc: {
          start: {
            line: 152,
            column: 20
          },
          end: {
            line: 152,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 152,
            column: 37
          },
          end: {
            line: 152,
            column: 41
          }
        }, {
          start: {
            line: 152,
            column: 44
          },
          end: {
            line: 152,
            column: 63
          }
        }],
        line: 152
      },
      "6": {
        loc: {
          start: {
            line: 249,
            column: 23
          },
          end: {
            line: 249,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 249,
            column: 23
          },
          end: {
            line: 249,
            column: 30
          }
        }, {
          start: {
            line: 249,
            column: 34
          },
          end: {
            line: 249,
            column: 45
          }
        }],
        line: 249
      },
      "7": {
        loc: {
          start: {
            line: 255,
            column: 13
          },
          end: {
            line: 255,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 255,
            column: 26
          },
          end: {
            line: 255,
            column: 27
          }
        }, {
          start: {
            line: 255,
            column: 30
          },
          end: {
            line: 255,
            column: 31
          }
        }],
        line: 255
      },
      "8": {
        loc: {
          start: {
            line: 260,
            column: 12
          },
          end: {
            line: 266,
            column: 17
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 261,
            column: 16
          },
          end: {
            line: 261,
            column: 18
          }
        }, {
          start: {
            line: 262,
            column: 16
          },
          end: {
            line: 266,
            column: 17
          }
        }],
        line: 260
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c65488675257bca7796c8f9a6ca8816874c773f8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_k86gbahkc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_k86gbahkc();
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// To meet accessibility standards, the Popover component must receive either title, aria-labelledby, or aria-label.

var CLOSE_TIMEOUT_MS = (cov_k86gbahkc().s[0]++, 500);
var CONTENT_CLASS_NAME = (cov_k86gbahkc().s[1]++, {
  base: 'BricksPopover__Content',
  afterOpen: 'BricksPopover__Content--after-open',
  beforeClose: 'BricksPopover__Content--before-close'
});
var OVERLAY_CLASS_NAME = (cov_k86gbahkc().s[2]++, {
  base: 'BricksPopover__Overlay',
  afterOpen: 'BricksPopover__Overlay--after-open',
  beforeClose: 'BricksPopover__Overlay--before-close'
});

/**
 * Full-screen modals cover the entire screen. This surface sits above the main
 * surface covering the navigation and allowing for an immersive experience. We
 * use these for content-rich - full user focus to consumer content or for PDP
 * pages or How it works pages.
 *
 * Header Props
 *
 *
 * ----------------
 *
 * Full-screen modals render header and footer content based on props:
 *
 * *   The close icon renders when you pass `onRequestClose` (this is required)
 *
 * *   A back icon renders when you pass `onBackClick`
 *
 * *   Dividers between the header, children, and footer render when you pass
 * `showDividers={true}`
 *
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * It's required to pass one of these props: `title`, `aria-labelledby`, or
 * `aria-label`. We recommend passing `title` (if you do that, the component
 * will render the appropriate `aria-labelledby` attribute for you).
 *
 * <FullScreenModal title="My Modal"> <Text>Content</Text> </FullScreenModal>
 *
 * <FullScreenModal aria-labelledby="modal-heading"> <Box> <Text
 * id="modal-heading">Heading</Text> <Text>Content</Text> </Box>
 * </FullScreenModal>
 *
 * // Acceptable, but try to avoid because there's no visible text label
 * <FullScreenModal aria-label="Modal with Content"> <Image />
 * </FullScreenModal>
 *
 *
 * Analytics
 *
 *
 * -------------
 *
 * To track:
 *
 * *   Modal impression events (`boxViewEvent: { targetName: "example" }`), pass
 * `analyticsName` and `trackBoxImpression={true}`
 *
 * *   Back button click events (`buttonClickEvent: { targetName: "example-back"
 * }`), pass `analyticsName` and `onBackClick`
 *
 * *   Back button impression events (`buttonViewEvent: { targetName:
 * "example-back" }`), pass `analyticsName`, `onBackClick` and
 * `trackButtonImpressions={true}`
 *
 * *   Close button click events (`buttonClickEvent: { targetName:
 * "example-close" }`), pass `analyticsName`
 *
 * *   Close button impression events (`buttonViewEvent: { targetName:
 * "example-close" }`), pass `analyticsName` and `trackButtonImpressions={true}`
 */
cov_k86gbahkc().s[3]++;
var FullScreenModal = exports.FullScreenModal = function FullScreenModal(_ref) {
  var _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? (cov_k86gbahkc().b[0][0]++, false) : _ref$isOpen,
    onRequestClose = _ref.onRequestClose,
    _ref$headerIconButton = _ref.headerIconButtonVariant,
    headerIconButtonVariant = _ref$headerIconButton === void 0 ? (cov_k86gbahkc().b[1][0]++, 'icon') : _ref$headerIconButton,
    title = _ref.title,
    subtitle = _ref.subtitle,
    id = _ref.id,
    analyticsName = _ref.analyticsName,
    trackBoxImpression = _ref.trackBoxImpression,
    trackButtonImpressions = _ref.trackButtonImpressions,
    onBackClick = _ref.onBackClick,
    _ref$showScrollbar = _ref.showScrollbar,
    showScrollbar = _ref$showScrollbar === void 0 ? (cov_k86gbahkc().b[2][0]++, true) : _ref$showScrollbar,
    _ref$hasPadding = _ref.hasPadding,
    hasPadding = _ref$hasPadding === void 0 ? (cov_k86gbahkc().b[3][0]++, true) : _ref$hasPadding,
    themeProps = _ref.themeProps,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_k86gbahkc().f[0]++;
  var ariaLabelledBy = (cov_k86gbahkc().s[4]++, title ? (cov_k86gbahkc().b[4][0]++, (0, _NavigationBar.getNavigationBarTitleId)({
    id: id
  })) : (cov_k86gbahkc().b[4][1]++, props['aria-labelledby']));
  var ariaLabel = (cov_k86gbahkc().s[5]++, ariaLabelledBy ? (cov_k86gbahkc().b[5][0]++, null) : (cov_k86gbahkc().b[5][1]++, props['aria-label']));
  cov_k86gbahkc().s[6]++;
  (0, _shared.useDisabledBodyScroll)(isOpen);
  var _ref2 = (cov_k86gbahkc().s[7]++, (0, _react.useState)(false)),
    _ref3 = _slicedToArray(_ref2, 2),
    showDivider = _ref3[0],
    setShowDivider = _ref3[1];
  var handleScroll = (cov_k86gbahkc().s[8]++, (0, _react.useCallback)(function (e) {
    cov_k86gbahkc().f[1]++;
    cov_k86gbahkc().s[9]++;
    return setShowDivider(e.currentTarget.scrollTop > 0);
  }, []));
  var _ref4 = (cov_k86gbahkc().s[10]++, (0, _theme.useTheme)()),
    colors = _ref4.colors;
  var contentStyles = (cov_k86gbahkc().s[11]++, {
    height: '100vh',
    width: '100vw',
    outline: 'none',
    border: 'none',
    WebkitOverflowScrolling: 'touch',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column'
  });
  var overlayStyles = (cov_k86gbahkc().s[12]++, {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: colors.neutrals0,
    overflowY: 'hidden'
  });
  var globalStyles = (cov_k86gbahkc().s[13]++, /*#__PURE__*/(0, _react2.css)(".", OVERLAY_CLASS_NAME.base, "{opacity:0;transition:opacity ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", OVERLAY_CLASS_NAME.afterOpen, "{opacity:1;}.", OVERLAY_CLASS_NAME.beforeClose, "{opacity:0;}.", CONTENT_CLASS_NAME.base, "{transform:translateY(10%);transition:transform ", CLOSE_TIMEOUT_MS, "ms ease-out;}.", CONTENT_CLASS_NAME.afterOpen, "{transform:translateY(0);}.", CONTENT_CLASS_NAME.beforeClose, "{transform:translateY(10%);}" + (process.env.NODE_ENV === "production" ? "" : ";label:globalStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wbGV4L01vZGFsL0Z1bGxTY3JlZW5Nb2RhbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBMEwwQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcGxleC9Nb2RhbC9GdWxsU2NyZWVuTW9kYWwudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IFByb3BzV2l0aENoaWxkcmVuLCB1c2VDYWxsYmFjaywgdXNlU3RhdGUgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUmVhY3RNb2RhbCBmcm9tICdyZWFjdC1tb2RhbCc7XG5cbmltcG9ydCB7IGNzcywgR2xvYmFsIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5pbXBvcnQgeyBCb3ggfSBmcm9tICcuLi8uLi9jb3JlJztcbmltcG9ydCB7IHVzZVRoZW1lIH0gZnJvbSAnLi4vLi4vc3lzdGVtL3RoZW1lJztcbmltcG9ydCB7IFRoZW1lZExpdGUgfSBmcm9tICcuLi8uLi90aGVtZS9PRFRoZW1lTGl0ZSc7XG5pbXBvcnQgeyBUaGVtZWRQcm9wcyB9IGZyb20gJy4uLy4uL3RoZW1lL1RoZW1lZFByb3BzJztcbmltcG9ydCB7IGdldE5hdmlnYXRpb25CYXJUaXRsZUlkIH0gZnJvbSAnLi9OYXZpZ2F0aW9uQmFyJztcbmltcG9ydCB7IE1vZGFsQTExeVByb3BzLCBNb2RhbEhlYWRlciwgdXNlRGlzYWJsZWRCb2R5U2Nyb2xsIH0gZnJvbSAnLi9zaGFyZWQnO1xuXG50eXBlIEZ1bGxTY3JlZW5CYXNlUHJvcHMgPSBQcm9wc1dpdGhDaGlsZHJlbjx7XG4gIC8qKiBXaGV0aGVyIHRoZSBtb2RhbCBpcyBvcGVuICovXG4gIGlzT3BlbjogYm9vbGVhbjtcbiAgLyoqIENhbGxlZCB3aGVuIHRoZSBYIGJ1dHRvbiBpcyBjbGlja2VkICovXG4gIG9uUmVxdWVzdENsb3NlOiAoKSA9PiB2b2lkO1xuICAvKiogQ2FsbGVkIHdoZW4gdGhlIGJhY2sgYnV0dG9uIGlzIGNsaWNrZWQgKGJhY2sgYnV0dG9uIG9ubHkgcmVuZGVyZWQgaWYgcHJvdmlkZWQpICovXG4gIG9uQmFja0NsaWNrPzogKCkgPT4gdm9pZDtcbiAgLyoqIFRpdGxlIG9mIHRoZSBtb2RhbCAqL1xuICB0aXRsZT86IHN0cmluZztcbiAgLyoqIFN1YnRpdGxlIG9mIHRoZSBtb2RhbCAqL1xuICBzdWJ0aXRsZT86IHN0cmluZztcbiAgLyoqICBIZWFkZXIgaWNvbnMgdmFyaWFudDogaWNvbiBoYXMgYSBjaXJjbGUgJiBnaG9zdCBpcyBubyBjaXJjbGUuIERlZmF1bHRzIHRvIGljb24gICovXG4gIGhlYWRlckljb25CdXR0b25WYXJpYW50PzogJ2ljb24nIHwgJ2dob3N0JztcbiAgLyoqIE9wdGlvbmFsIGlkIGZvciB0aGUgbW9kYWwgaGVhZGVyICovXG4gIGlkPzogc3RyaW5nO1xuICAvKiogT3B0aW9uIHRvIHNob3cgc2Nyb2xsYmFyIC0gZGVmYXVsdHMgdG8gc2hvdyBzY3JvbGxiYXIgKi9cbiAgc2hvd1Njcm9sbGJhcj86IGJvb2xlYW47XG4gIC8qKiBPcHRpb24gdG8gaGF2ZSBwYWRkaW5nIC0gZGVmYXVsdHMgdG8gdHJ1ZSAqL1xuICBoYXNQYWRkaW5nPzogYm9vbGVhbjtcbiAgLyoqXG4gICAqIFNldCB0aGUgbW9kYWwgdG8gdXNlIGEgY3VzdG9tIHRoZW1lIC0gaWYgdW5kZWZpbmVkIGl0IGRlZmF1bHRzIHRvIFRoZW1lTGl0ZSdzIGRlZmF1bHQgdGhlbWVcbiAgICovXG4gIHRoZW1lUHJvcHM/OiBUaGVtZWRQcm9wcztcbn0+O1xuXG5pbnRlcmZhY2UgRnVsbFNjcmVlbkFuYWx5dGljc1Byb3BzIHtcbiAgLyoqXG4gICAqIE5hbWUgb2YgdGhlIGZ1bGxzY3JlZW4gaW4gYW5hbHl0aWNzIGV2ZW50cywgc2hvdWxkIGJlIHVuaXF1ZSB3aXRoaW4gdGhlIGFwcFxuICAgKiBDb252ZW50aW9uOiB7YXBwTmFtZX0te3BvcG92ZXJOYW1lfVxuICAgKi9cbiAgYW5hbHl0aWNzTmFtZTogc3RyaW5nO1xuICAvKiogV2hldGhlciB0byB0cmFjayBpbXByZXNzaW9uIGV2ZW50cyBmb3IgdGhlIGhlYWRlciBib3ggKi9cbiAgdHJhY2tCb3hJbXByZXNzaW9uPzogYm9vbGVhbjtcbiAgLyoqIFdoZXRoZXIgdG8gdHJhY2sgaW1wcmVzc2lvbiBldmVudHMgZm9yIHRoZSBoZWFkZXIgYnV0dG9ucyAqL1xuICB0cmFja0J1dHRvbkltcHJlc3Npb25zPzogYm9vbGVhbjtcbn1cblxuLy8gVG8gbWVldCBhY2Nlc3NpYmlsaXR5IHN0YW5kYXJkcywgdGhlIFBvcG92ZXIgY29tcG9uZW50IG11c3QgcmVjZWl2ZSBlaXRoZXIgdGl0bGUsIGFyaWEtbGFiZWxsZWRieSwgb3IgYXJpYS1sYWJlbC5cbnR5cGUgVGl0bGVQcm9wcyA9IHsgdGl0bGU6IHN0cmluZyB9O1xudHlwZSBOb1RpdGxlUHJvcHMgPSB7IHRpdGxlPzogbmV2ZXIgfTtcbnR5cGUgRnVsbFNjcmVlbkExMXlQcm9wcyA9IE1vZGFsQTExeVByb3BzPFRpdGxlUHJvcHMsIE5vVGl0bGVQcm9wcz47XG5cbmV4cG9ydCB0eXBlIEZ1bGxTY3JlZW5Nb2RhbFByb3BzID0gRnVsbFNjcmVlbkJhc2VQcm9wcyAmXG4gIEZ1bGxTY3JlZW5BbmFseXRpY3NQcm9wcyAmXG4gIEZ1bGxTY3JlZW5BMTF5UHJvcHM7XG5cbmNvbnN0IENMT1NFX1RJTUVPVVRfTVMgPSA1MDA7XG5jb25zdCBDT05URU5UX0NMQVNTX05BTUUgPSB7XG4gIGJhc2U6ICdCcmlja3NQb3BvdmVyX19Db250ZW50JyxcbiAgYWZ0ZXJPcGVuOiAnQnJpY2tzUG9wb3Zlcl9fQ29udGVudC0tYWZ0ZXItb3BlbicsXG4gIGJlZm9yZUNsb3NlOiAnQnJpY2tzUG9wb3Zlcl9fQ29udGVudC0tYmVmb3JlLWNsb3NlJyxcbn07XG5jb25zdCBPVkVSTEFZX0NMQVNTX05BTUUgPSB7XG4gIGJhc2U6ICdCcmlja3NQb3BvdmVyX19PdmVybGF5JyxcbiAgYWZ0ZXJPcGVuOiAnQnJpY2tzUG9wb3Zlcl9fT3ZlcmxheS0tYWZ0ZXItb3BlbicsXG4gIGJlZm9yZUNsb3NlOiAnQnJpY2tzUG9wb3Zlcl9fT3ZlcmxheS0tYmVmb3JlLWNsb3NlJyxcbn07XG5cbi8qKlxuICogRnVsbC1zY3JlZW4gbW9kYWxzIGNvdmVyIHRoZSBlbnRpcmUgc2NyZWVuLiBUaGlzIHN1cmZhY2Ugc2l0cyBhYm92ZSB0aGUgbWFpblxuICogc3VyZmFjZSBjb3ZlcmluZyB0aGUgbmF2aWdhdGlvbiBhbmQgYWxsb3dpbmcgZm9yIGFuIGltbWVyc2l2ZSBleHBlcmllbmNlLiBXZVxuICogdXNlIHRoZXNlIGZvciBjb250ZW50LXJpY2ggLSBmdWxsIHVzZXIgZm9jdXMgdG8gY29uc3VtZXIgY29udGVudCBvciBmb3IgUERQXG4gKiBwYWdlcyBvciBIb3cgaXQgd29ya3MgcGFnZXMuXG4gKlxuICogSGVhZGVyIFByb3BzXG4gKlxuICpcbiAqIC0tLS0tLS0tLS0tLS0tLS1cbiAqXG4gKiBGdWxsLXNjcmVlbiBtb2RhbHMgcmVuZGVyIGhlYWRlciBhbmQgZm9vdGVyIGNvbnRlbnQgYmFzZWQgb24gcHJvcHM6XG4gKlxuICogKiAgIFRoZSBjbG9zZSBpY29uIHJlbmRlcnMgd2hlbiB5b3UgcGFzcyBgb25SZXF1ZXN0Q2xvc2VgICh0aGlzIGlzIHJlcXVpcmVkKVxuICpcbiAqICogICBBIGJhY2sgaWNvbiByZW5kZXJzIHdoZW4geW91IHBhc3MgYG9uQmFja0NsaWNrYFxuICpcbiAqICogICBEaXZpZGVycyBiZXR3ZWVuIHRoZSBoZWFkZXIsIGNoaWxkcmVuLCBhbmQgZm9vdGVyIHJlbmRlciB3aGVuIHlvdSBwYXNzXG4gKiBgc2hvd0RpdmlkZXJzPXt0cnVlfWBcbiAqXG4gKlxuICogQWNjZXNzaWJpbGl0eVxuICpcbiAqXG4gKiAtLS0tLS0tLS0tLS0tLS0tLVxuICpcbiAqIEl0J3MgcmVxdWlyZWQgdG8gcGFzcyBvbmUgb2YgdGhlc2UgcHJvcHM6IGB0aXRsZWAsIGBhcmlhLWxhYmVsbGVkYnlgLCBvclxuICogYGFyaWEtbGFiZWxgLiBXZSByZWNvbW1lbmQgcGFzc2luZyBgdGl0bGVgIChpZiB5b3UgZG8gdGhhdCwgdGhlIGNvbXBvbmVudFxuICogd2lsbCByZW5kZXIgdGhlIGFwcHJvcHJpYXRlIGBhcmlhLWxhYmVsbGVkYnlgIGF0dHJpYnV0ZSBmb3IgeW91KS5cbiAqXG4gKiA8RnVsbFNjcmVlbk1vZGFsIHRpdGxlPVwiTXkgTW9kYWxcIj4gPFRleHQ+Q29udGVudDwvVGV4dD4gPC9GdWxsU2NyZWVuTW9kYWw+XG4gKlxuICogPEZ1bGxTY3JlZW5Nb2RhbCBhcmlhLWxhYmVsbGVkYnk9XCJtb2RhbC1oZWFkaW5nXCI+IDxCb3g+IDxUZXh0XG4gKiBpZD1cIm1vZGFsLWhlYWRpbmdcIj5IZWFkaW5nPC9UZXh0PiA8VGV4dD5Db250ZW50PC9UZXh0PiA8L0JveD5cbiAqIDwvRnVsbFNjcmVlbk1vZGFsPlxuICpcbiAqIC8vIEFjY2VwdGFibGUsIGJ1dCB0cnkgdG8gYXZvaWQgYmVjYXVzZSB0aGVyZSdzIG5vIHZpc2libGUgdGV4dCBsYWJlbFxuICogPEZ1bGxTY3JlZW5Nb2RhbCBhcmlhLWxhYmVsPVwiTW9kYWwgd2l0aCBDb250ZW50XCI+IDxJbWFnZSAvPlxuICogPC9GdWxsU2NyZWVuTW9kYWw+XG4gKlxuICpcbiAqIEFuYWx5dGljc1xuICpcbiAqXG4gKiAtLS0tLS0tLS0tLS0tXG4gKlxuICogVG8gdHJhY2s6XG4gKlxuICogKiAgIE1vZGFsIGltcHJlc3Npb24gZXZlbnRzIChgYm94Vmlld0V2ZW50OiB7IHRhcmdldE5hbWU6IFwiZXhhbXBsZVwiIH1gKSwgcGFzc1xuICogYGFuYWx5dGljc05hbWVgIGFuZCBgdHJhY2tCb3hJbXByZXNzaW9uPXt0cnVlfWBcbiAqXG4gKiAqICAgQmFjayBidXR0b24gY2xpY2sgZXZlbnRzIChgYnV0dG9uQ2xpY2tFdmVudDogeyB0YXJnZXROYW1lOiBcImV4YW1wbGUtYmFja1wiXG4gKiB9YCksIHBhc3MgYGFuYWx5dGljc05hbWVgIGFuZCBgb25CYWNrQ2xpY2tgXG4gKlxuICogKiAgIEJhY2sgYnV0dG9uIGltcHJlc3Npb24gZXZlbnRzIChgYnV0dG9uVmlld0V2ZW50OiB7IHRhcmdldE5hbWU6XG4gKiBcImV4YW1wbGUtYmFja1wiIH1gKSwgcGFzcyBgYW5hbHl0aWNzTmFtZWAsIGBvbkJhY2tDbGlja2AgYW5kXG4gKiBgdHJhY2tCdXR0b25JbXByZXNzaW9ucz17dHJ1ZX1gXG4gKlxuICogKiAgIENsb3NlIGJ1dHRvbiBjbGljayBldmVudHMgKGBidXR0b25DbGlja0V2ZW50OiB7IHRhcmdldE5hbWU6XG4gKiBcImV4YW1wbGUtY2xvc2VcIiB9YCksIHBhc3MgYGFuYWx5dGljc05hbWVgXG4gKlxuICogKiAgIENsb3NlIGJ1dHRvbiBpbXByZXNzaW9uIGV2ZW50cyAoYGJ1dHRvblZpZXdFdmVudDogeyB0YXJnZXROYW1lOlxuICogXCJleGFtcGxlLWNsb3NlXCIgfWApLCBwYXNzIGBhbmFseXRpY3NOYW1lYCBhbmQgYHRyYWNrQnV0dG9uSW1wcmVzc2lvbnM9e3RydWV9YFxuICovXG5leHBvcnQgY29uc3QgRnVsbFNjcmVlbk1vZGFsOiBSZWFjdC5GQzxGdWxsU2NyZWVuTW9kYWxQcm9wcz4gPSAoe1xuICBpc09wZW4gPSBmYWxzZSxcbiAgb25SZXF1ZXN0Q2xvc2UsXG4gIGhlYWRlckljb25CdXR0b25WYXJpYW50ID0gJ2ljb24nLFxuICB0aXRsZSxcbiAgc3VidGl0bGUsXG4gIGlkLFxuICBhbmFseXRpY3NOYW1lLFxuICB0cmFja0JveEltcHJlc3Npb24sXG4gIHRyYWNrQnV0dG9uSW1wcmVzc2lvbnMsXG4gIG9uQmFja0NsaWNrLFxuICBzaG93U2Nyb2xsYmFyID0gdHJ1ZSxcbiAgaGFzUGFkZGluZyA9IHRydWUsXG4gIHRoZW1lUHJvcHMsXG4gIC4uLnByb3BzXG59KSA9PiB7XG4gIGNvbnN0IGFyaWFMYWJlbGxlZEJ5ID0gdGl0bGUgPyBnZXROYXZpZ2F0aW9uQmFyVGl0bGVJZCh7IGlkIH0pIDogcHJvcHNbJ2FyaWEtbGFiZWxsZWRieSddO1xuICBjb25zdCBhcmlhTGFiZWwgPSBhcmlhTGFiZWxsZWRCeSA/IG51bGwgOiBwcm9wc1snYXJpYS1sYWJlbCddO1xuICB1c2VEaXNhYmxlZEJvZHlTY3JvbGwoaXNPcGVuKTtcbiAgY29uc3QgW3Nob3dEaXZpZGVyLCBzZXRTaG93RGl2aWRlcl0gPSB1c2VTdGF0ZShmYWxzZSk7XG4gIGNvbnN0IGhhbmRsZVNjcm9sbCA9IHVzZUNhbGxiYWNrPFJlYWN0LlVJRXZlbnRIYW5kbGVyPEhUTUxEaXZFbGVtZW50Pj4oXG4gICAgKGUpID0+IHNldFNob3dEaXZpZGVyKGUuY3VycmVudFRhcmdldC5zY3JvbGxUb3AgPiAwKSxcbiAgICBbXSxcbiAgKTtcblxuICBjb25zdCB7IGNvbG9ycyB9ID0gdXNlVGhlbWUoKTtcblxuICBjb25zdCBjb250ZW50U3R5bGVzOiBSZWFjdC5DU1NQcm9wZXJ0aWVzID0ge1xuICAgIGhlaWdodDogJzEwMHZoJyxcbiAgICB3aWR0aDogJzEwMHZ3JyxcbiAgICBvdXRsaW5lOiAnbm9uZScsXG4gICAgYm9yZGVyOiAnbm9uZScsXG4gICAgV2Via2l0T3ZlcmZsb3dTY3JvbGxpbmc6ICd0b3VjaCcsXG4gICAgb3ZlcmZsb3c6ICdhdXRvJyxcbiAgICBkaXNwbGF5OiAnZmxleCcsXG4gICAgZmxleERpcmVjdGlvbjogJ2NvbHVtbicsXG4gIH07XG5cbiAgY29uc3Qgb3ZlcmxheVN0eWxlczogUmVhY3QuQ1NTUHJvcGVydGllcyA9IHtcbiAgICBwb3NpdGlvbjogJ2ZpeGVkJyxcbiAgICB0b3A6IDAsXG4gICAgbGVmdDogMCxcbiAgICBoZWlnaHQ6ICcxMDB2aCcsXG4gICAgd2lkdGg6ICcxMDB2dycsXG4gICAgekluZGV4OiA5OTksXG4gICAgZGlzcGxheTogJ2ZsZXgnLFxuICAgIGFsaWduSXRlbXM6ICdjZW50ZXInLFxuICAgIGp1c3RpZnlDb250ZW50OiAnY2VudGVyJyxcbiAgICBiYWNrZ3JvdW5kOiBjb2xvcnMubmV1dHJhbHMwLFxuICAgIG92ZXJmbG93WTogJ2hpZGRlbicsXG4gIH07XG5cbiAgY29uc3QgZ2xvYmFsU3R5bGVzID0gY3NzYFxuICAgIC4ke09WRVJMQVlfQ0xBU1NfTkFNRS5iYXNlfSB7XG4gICAgICBvcGFjaXR5OiAwO1xuICAgICAgdHJhbnNpdGlvbjogb3BhY2l0eSAke0NMT1NFX1RJTUVPVVRfTVN9bXMgZWFzZS1vdXQ7XG4gICAgfVxuICAgIC4ke09WRVJMQVlfQ0xBU1NfTkFNRS5hZnRlck9wZW59IHtcbiAgICAgIG9wYWNpdHk6IDE7XG4gICAgfVxuICAgIC4ke09WRVJMQVlfQ0xBU1NfTkFNRS5iZWZvcmVDbG9zZX0ge1xuICAgICAgb3BhY2l0eTogMDtcbiAgICB9XG4gICAgLiR7Q09OVEVOVF9DTEFTU19OQU1FLmJhc2V9IHtcbiAgICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgxMCUpO1xuICAgICAgdHJhbnNpdGlvbjogdHJhbnNmb3JtICR7Q0xPU0VfVElNRU9VVF9NU31tcyBlYXNlLW91dDtcbiAgICB9XG4gICAgLiR7Q09OVEVOVF9DTEFTU19OQU1FLmFmdGVyT3Blbn0ge1xuICAgICAgdHJhbnNmb3JtOiB0cmFuc2xhdGVZKDApO1xuICAgIH1cbiAgICAuJHtDT05URU5UX0NMQVNTX05BTUUuYmVmb3JlQ2xvc2V9IHtcbiAgICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgxMCUpO1xuICAgIH1cbiAgYDtcblxuICByZXR1cm4gKFxuICAgIDxSZWFjdE1vZGFsXG4gICAgICBpc09wZW49e2lzT3Blbn1cbiAgICAgIG9uUmVxdWVzdENsb3NlPXtvblJlcXVlc3RDbG9zZX1cbiAgICAgIGNsYXNzTmFtZT17Q09OVEVOVF9DTEFTU19OQU1FfVxuICAgICAgb3ZlcmxheUNsYXNzTmFtZT17T1ZFUkxBWV9DTEFTU19OQU1FfVxuICAgICAgY2xvc2VUaW1lb3V0TVM9e0NMT1NFX1RJTUVPVVRfTVN9XG4gICAgICBzdHlsZT17eyBjb250ZW50OiBjb250ZW50U3R5bGVzLCBvdmVybGF5OiBvdmVybGF5U3R5bGVzIH19XG4gICAgICAvKlxuICAgICAgICBBY2Nlc3NpYmlsaXR5IG5vdGU6IEFyaWEtbW9kZWwgaW5kaWNhdGVzIHRoZSBwcmVzZW5jZSBvZiBhIG1vZGFsIGVsZW1lbnRcbiAgICAgICAgaHR0cHM6Ly93d3cudzMub3JnL1RSL3dhaS1hcmlhLTEuMi8jYXJpYS1tb2RhbFxuICAgICAgKi9cbiAgICAgIGFyaWEtbW9kYWw9e2lzT3Blbn1cbiAgICAgIC8qXG4gICAgICAgIEFjY2Vzc2liaWxpdHkgbm90ZTogdXNlIHRoZSBjb250ZW50TGFiZWwgcHJvcCB0byBwcm92aWRlIGEgbGFiZWwgZm9yIHRoZSBtb2RhbCBjb250ZW50XG4gICAgICAgIElmIHRoZSBtb2RhbCBpcyBhbHJlYWR5IGxhYmVsZWQgd2l0aCB2aXNpYmxlIHRleHQsIHlvdSBzaG91bGQgc3BlY2lmeSB0aGUgZWxlbWVudCBpbmNsdWRpbmcgdGhlIGxhYmVsIHdpdGggdGhlIGFyaWEtbGFiZWxsZWRieSBhdHRyaWJ1dGUuXG4gICAgICAgIGh0dHBzOi8vcmVhY3Rjb21tdW5pdHkub3JnL3JlYWN0LW1vZGFsL2FjY2Vzc2liaWxpdHkvI2FyaWEtYXR0cmlidXRlc1xuICAgICAgICBUbyBzZXQgYXJpYS1sYWJlbGxlZGJ5LCBlaXRoZXIgKDEpIHBhc3MgaGVhZGVyUHJvcHMudGl0bGUgYW5kIGxldCB0aGlzIGNvbXBvbmVudCBzZXQgYXJpYS1sYWJlbGxlZGJ5IGZvciB5b3UsIG9yICgyKSBwYXNzIGFyaWFMYWJlbGxlZEJ5XG4gICAgICAgIGFuZCBzZXQgaXQgdG8gdGhlIGlkIG9mIHlvdXIgY3VzdG9tIGxhYmVsXG4gICAgICAqL1xuICAgICAgYXJpYT17eyBsYWJlbGxlZGJ5OiBhcmlhTGFiZWxsZWRCeSB9fVxuICAgICAgY29udGVudExhYmVsPXthcmlhTGFiZWx9XG4gICAgPlxuICAgICAgPEdsb2JhbCBzdHlsZXM9e2dsb2JhbFN0eWxlc30gLz5cblxuICAgICAgey8qXG4gICAgICAgICAgTk9URTogV3JhcHBpbmcgY2hpbGRyZW4gaW4gPFRoZW1lZExpdGUgLz4gc2luY2UgdXN1YWxseSB0aGUgbW9kYWwgaXMgYVxuICAgICAgICAgIHNpYmxpbmcgdG8gYW55IHJvb3QgQXBwIGNvbXBvbmVudCB0aGF0IGlzIHdyYXBwZWQgaW4gdGhlIHRoZW1lXG4gICAgICAqL31cbiAgICAgIDxUaGVtZWRMaXRlIHsuLi50aGVtZVByb3BzfT5cbiAgICAgICAgPE1vZGFsSGVhZGVyXG4gICAgICAgICAgdHJhY2tCb3hJbXByZXNzaW9uPXt0cmFja0JveEltcHJlc3Npb259XG4gICAgICAgICAgdHJhY2tCdXR0b25JbXByZXNzaW9ucz17dHJhY2tCdXR0b25JbXByZXNzaW9uc31cbiAgICAgICAgICBhbmFseXRpY3NOYW1lPXthbmFseXRpY3NOYW1lfVxuICAgICAgICAgIG9uUmVxdWVzdENsb3NlPXtvblJlcXVlc3RDbG9zZX1cbiAgICAgICAgICB0aXRsZT17dGl0bGV9XG4gICAgICAgICAgc3VidGl0bGU9e3N1YnRpdGxlfVxuICAgICAgICAgIGlkPXtpZH1cbiAgICAgICAgICAvLyBvbmx5IHNob3dzIGRpdmlkZXIgaWYgdGl0bGUgaXMgcHJlc2VudCBvciB3aGVuIHNjcm9sbGluZ1xuICAgICAgICAgIHNob3dEaXZpZGVyPXshIXRpdGxlIHx8IHNob3dEaXZpZGVyfVxuICAgICAgICAgIGhlYWRlckljb25CdXR0b25WYXJpYW50PXtoZWFkZXJJY29uQnV0dG9uVmFyaWFudH1cbiAgICAgICAgICBvbkJhY2tDbGljaz17b25CYWNrQ2xpY2t9XG4gICAgICAgIC8+XG4gICAgICAgIHsvKiBBZGQgY3VzdG9tIHN0eWxpbmcgZm9yIHRoZSBjb250ZW50IGJ5IGFkZGluZyBpdCB0byBwcm9wcy5jaGlsZHJlbiAqL31cbiAgICAgICAgPEJveFxuICAgICAgICAgIHA9e2hhc1BhZGRpbmcgPyA1IDogMH1cbiAgICAgICAgICBvblNjcm9sbD17aGFuZGxlU2Nyb2xsfVxuICAgICAgICAgIG92ZXJmbG93WT1cInNjcm9sbFwiXG4gICAgICAgICAgZmxleD17MX1cbiAgICAgICAgICBzeD17XG4gICAgICAgICAgICBzaG93U2Nyb2xsYmFyXG4gICAgICAgICAgICAgID8ge31cbiAgICAgICAgICAgICAgOiB7XG4gICAgICAgICAgICAgICAgICAnJjo6LXdlYmtpdC1zY3JvbGxiYXInOiB7IGRpc3BsYXk6ICdub25lJyB9LFxuICAgICAgICAgICAgICAgICAgbXNPdmVyZmxvd1N0eWxlOiAnbm9uZScsXG4gICAgICAgICAgICAgICAgICBzY3JvbGxiYXJXaWR0aDogJ25vbmUnLFxuICAgICAgICAgICAgICAgIH1cbiAgICAgICAgICB9XG4gICAgICAgID5cbiAgICAgICAgICB7cHJvcHMuY2hpbGRyZW59XG4gICAgICAgIDwvQm94PlxuICAgICAgPC9UaGVtZWRMaXRlPlxuICAgIDwvUmVhY3RNb2RhbD5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEZ1bGxTY3JlZW5Nb2RhbDtcbiJdfQ== */"));
  cov_k86gbahkc().s[14]++;
  return /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    className: CONTENT_CLASS_NAME,
    overlayClassName: OVERLAY_CLASS_NAME,
    closeTimeoutMS: CLOSE_TIMEOUT_MS,
    style: {
      content: contentStyles,
      overlay: overlayStyles
    }
    /*
      Accessibility note: Aria-model indicates the presence of a modal element
      https://www.w3.org/TR/wai-aria-1.2/#aria-modal
    */,
    "aria-modal": isOpen
    /*
      Accessibility note: use the contentLabel prop to provide a label for the modal content
      If the modal is already labeled with visible text, you should specify the element including the label with the aria-labelledby attribute.
      https://reactcommunity.org/react-modal/accessibility/#aria-attributes
      To set aria-labelledby, either (1) pass headerProps.title and let this component set aria-labelledby for you, or (2) pass ariaLabelledBy
      and set it to the id of your custom label
    */,
    aria: {
      labelledby: ariaLabelledBy
    },
    contentLabel: ariaLabel
  }, /*#__PURE__*/_react["default"].createElement(_react2.Global, {
    styles: globalStyles
  }), /*#__PURE__*/_react["default"].createElement(_ODThemeLite.ThemedLite, themeProps, /*#__PURE__*/_react["default"].createElement(_shared.ModalHeader, {
    trackBoxImpression: trackBoxImpression,
    trackButtonImpressions: trackButtonImpressions,
    analyticsName: analyticsName,
    onRequestClose: onRequestClose,
    title: title,
    subtitle: subtitle,
    id: id
    // only shows divider if title is present or when scrolling
    ,
    showDivider: (cov_k86gbahkc().b[6][0]++, !!title) || (cov_k86gbahkc().b[6][1]++, showDivider),
    headerIconButtonVariant: headerIconButtonVariant,
    onBackClick: onBackClick
  }), /*#__PURE__*/_react["default"].createElement(_core.Box, {
    p: hasPadding ? (cov_k86gbahkc().b[7][0]++, 5) : (cov_k86gbahkc().b[7][1]++, 0),
    onScroll: handleScroll,
    overflowY: "scroll",
    flex: 1,
    sx: showScrollbar ? (cov_k86gbahkc().b[8][0]++, {}) : (cov_k86gbahkc().b[8][1]++, {
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      msOverflowStyle: 'none',
      scrollbarWidth: 'none'
    })
  }, props.children)));
};
var _default = exports["default"] = FullScreenModal;